import { Box, IconButton, styled, useMediaQuery } from "@mui/material";
import FlexBetween from "components/flexbox/FlexBetween";
import FlexBox from "components/flexbox/FlexBox";
import Scrollbar from "components/ScrollBar";
import { useState } from "react";
import ArrowLeftToLine from "icons/duotone/ArrowLeftToLine";
import MultiLevelMenu from "./MultiLevelMenu";
import MobileSidebar from "./MobileSidebar";

const TOP_HEADER_AREA = 70;

const SidebarWrapper = styled(Box)(({
  theme,
  compact
}) => ({
  height: "100vh",
  position: "fixed",
  width: compact ? 86 : 280,
  transition: "all .2s ease",
  zIndex: theme.zIndex.drawer,
  backgroundColor: theme.palette.background.paper,
  "&:hover": compact && {
    width: 280
  }
}));

const NavWrapper = styled(Box)(() => ({
  paddingLeft: 16,
  paddingRight: 16,
  height: "100%"
}));

const LogoContainer = styled(FlexBox)(({ theme, compact }) => ({
  alignItems: "center",
  justifyContent: compact ? "center" : "flex-start",
  minWidth: compact ? "54px" : "auto",
  transition: "all 0.2s ease",
  overflow: "hidden"
}));

const LogoImage = styled("img")(({ theme, compact }) => ({
  height: compact ? "32px" : "40px",
  width: "auto",
  maxWidth: compact ? "32px" : "160px",
  objectFit: "contain",
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "scale(1.02)"
  }
}));

const StyledArrow = styled(ArrowLeftToLine)(() => ({
  display: "block"
}));

const StyledIconButton = styled(IconButton)(({
  theme
}) => ({
  "&:hover": {
    backgroundColor: theme.palette.action.hover
  }
}));

// -----------------------------------------------------------------------------
const DashboardSidebar = props => {
  const {
    sidebarCompact,
    showMobileSideBar,
    setShowMobileSideBar,
    setSidebarCompact
  } = props;
  const [onHover, setOnHover] = useState(false);
  const downLg = useMediaQuery(theme => theme.breakpoints.down("lg"));

  // Activate compact when toggle button clicked and not on hover state
  const COMPACT = sidebarCompact && !onHover ? 1 : 0;

  // IF MOBILE
  if (downLg) {
    return <MobileSidebar 
      sidebarCompact={!!COMPACT} 
      showMobileSideBar={!!showMobileSideBar} 
      setShowMobileSideBar={setShowMobileSideBar} 
    />;
  }

  return (
    <SidebarWrapper 
      compact={sidebarCompact ? 1 : 0} 
      onMouseEnter={() => setOnHover(true)} 
      onMouseLeave={() => sidebarCompact && setOnHover(false)}
    >
      <FlexBetween 
        pt={2} 
        pr={2} 
        pl={sidebarCompact && !onHover ? 2 : 3} 
        pb={1} 
        height={TOP_HEADER_AREA}
      >
        {/* LOGO */}
        <LogoContainer compact={COMPACT}>
          <LogoImage 
            src="/nextgen/nextgen_logo.png"
            alt="NextGen Logo"
            compact={COMPACT}
          />
        </LogoContainer>

        {/* SIDEBAR COLLAPSE BUTTON */}
        {!COMPACT && (
          <StyledIconButton 
            onClick={setSidebarCompact}
            sx={{ ml: "auto" }}
          >
            <StyledArrow />
          </StyledIconButton>
        )}
      </FlexBetween>

      {/* NAVIGATION ITEMS */}
      <Scrollbar 
        autoHide 
        clickOnTrack={false} 
        sx={{
          overflowX: "hidden",
          maxHeight: `calc(100vh - ${TOP_HEADER_AREA}px)`
        }}
      >
        <NavWrapper>
          <MultiLevelMenu sidebarCompact={!!COMPACT} />
        </NavWrapper>
      </Scrollbar>
    </SidebarWrapper>
  );
};

export default DashboardSidebar;